import { useEffect, useRef } from 'react';
import { debounce } from '../../../../utils/commonUtils';

/**
 * Returns a stable debounced function (identity stable across renders).
 * Handler always sees latest callback via ref; debounce instance cancels on unmount.
 */
export function useStableDebouncedCallback(callback, delayMs) {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const debouncedRef = useRef(null);
  if (!debouncedRef.current) {
    debouncedRef.current = debounce((...args) => {
      callbackRef.current(...args);
    }, delayMs);
  }

  useEffect(() => () => {
    debouncedRef.current?.cancel?.();
  }, []);

  return debouncedRef.current;
}
